<template>
    <el-select
        filterable
        clearable
        v-model="selected"
        :multiple="multiple"
        :multiple-limit="multipleLimit"
        :disabled="deshabilitar"
    >
        <el-option v-for="i in filteredList()" :key="i.id" :label="i.name" :value="i.id"></el-option>
    </el-select>
</template>
<script>
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';

    export default {
        data: function () {
            return {
                selected: this.value,
                list: [],
                deshabilitar: this.disabled ? this.disabled : false
            }
        },
        props: ['value', 'multiple', 'multiple-limit', 'filter', 'institutions','disabled'],
        components: {
            ElSelect,
            ElOption
        },
        watch: {
            value: function (value) {
                this.selected = value;
            },
            selected: function(value){
                this.$emit('input', value);
            }
        },
        mounted: function(){
            this.list = this.institutions;
        },
        methods: {
            filteredList() {
                if (this.filter && this.filter.filter(item => item).length) {
                    return this.list.filter(item => this.filter.includes(item.ministry_id));
                }
                return this.list;
            }
        }
    }
</script>